<template>
  <edit :module="module" @save="save" :displayError="displayError" />
</template>

<script>
import dataStore from "@/services/api/store";
import edit from "../detail";
const COURSE_MODULE_STORE = "CoachCourseModules";

export default {
  props: ["course_id"],
  components: {
    edit
  },
  data() {
    return {
      module: {
        course: this.course_id,
        ordering: 0,
        exercises: []
      },
      displayError: ""
    };
  },
  methods: {
    save(mod) {
      dataStore
        .create(COURSE_MODULE_STORE, mod)
        .then(module => {
          this.module = module;
          this.displayError = "";
          this.$emit("displaySnackbar", "Saved");
          this.$router.push({ name: "editModule", params: { id: module.id } });
        })
        .catch(() => {
          this.displayError = "An error occurred while saving";
        });
    }
  }
};
</script>
